import Vue from "vue"
import { get } from "lodash"
import {
  fetchVersion,
  fetchCharacters,
  fetchCharacterGuidesByCharacterKey,
  fetchTierList,
} from "@/api/ssbu"

const state = () => ({
  doneLoadingStaticData: false,
  version: {},
  characters: {},
  tierList: {},
  guidesByCharacterKey: {},
  networkError: null,
})

const mutations = {
  "DONE_LOADING_STATIC_DATA": (state) => {
    Vue.set(state, "doneLoadingStaticData", true)
  },
  "UPDATE_VERSION": (state, version) => {
    Vue.set(state, "version", version)
  },
  "UPDATE_CHARACTERS": (state, characters) => {
    Vue.set(state, "characters", characters)
  },
  "UPDATE_TIER_LIST": (state, tierList) => {
    Vue.set(state, "tierList", tierList)
  },
  "UPDATE_CHARACTER_GUIDES": (state, { characterKey, guides }) => {
    Vue.set(state.guidesByCharacterKey, characterKey, guides)
  },
  "UPDATE_NETWORK_ERROR": (state, networkError) => {
    Vue.set(state, "networkError", networkError)
  },
}
const actions = {
  // Data bootstrapping
  async loadStaticData ({ commit, dispatch }) {
    await Promise.all([
      dispatch("loadVersion"),
      dispatch("loadCharacters"),
      dispatch("loadTierList"),
    ])
    commit("DONE_LOADING_STATIC_DATA")
  },
  async loadVersion ({ commit }) {
    const version = await fetchVersion()
    commit("UPDATE_VERSION", version)
  },
  async loadCharacters ({ commit }) {
    const characters = await fetchCharacters()
    commit("UPDATE_CHARACTERS", characters)
  },
  async loadTierList ({ commit }) {
    const tierList = await fetchTierList()
    commit("UPDATE_TIER_LIST", tierList)
  },
  async loadCharacterGuides ({ commit }, characterKey) {
    const guides = await fetchCharacterGuidesByCharacterKey(characterKey)
    commit("UPDATE_CHARACTER_GUIDES", { characterKey, guides })
  },
}

const getters = {
  isUserPro: (_state, _getters, rootState) => {
    const ssbuCapabilities = get(rootState, "User.userCapabilities.pro_content.super-smash-bros-ultimate")
    return !!ssbuCapabilities && ssbuCapabilities.includes("view")
  },
  getCharacters: state => state.characters,
  characterByKey: (state) => (characterKey) => {
    return Object.values(state.characters).find(({ key }) => key === characterKey)
  },
  characterByName: (state) => (characterName) => {
    return Object.values(state.characters).find(({ name }) => name === characterName)
  },
  characterTierByKey: (state) => (characterKey) => {
    for (const tierLetter in state.tierList) {
      if (Object.values(state.tierList[tierLetter]).find(({ key }) => key === characterKey)) {
        return tierLetter
      }
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/ssbu.js